const StatsAnnotations = function() {

    this.linesAnnotations = [
        "The first series had the least amount of lines out of all other series. This is even with the increase in episode 5 (Dream Job) which was probably due to Mark's descent into paranoia over Sophie and his failed promotion at JLB.",
    ]
}

export default StatsAnnotations;